import { render, staticRenderFns } from "./V2Suit.vue?vue&type=template&id=4148f27e&scoped=true&"
import script from "./V2Suit.vue?vue&type=script&lang=js&"
export * from "./V2Suit.vue?vue&type=script&lang=js&"
import style0 from "./V2Suit.vue?vue&type=style&index=0&id=4148f27e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4148f27e",
  null
  
)

export default component.exports